module.exports = __webpack_public_path__ + "202669:9205d1a92be8207f1496/img/carousel_04@2x.bf73cd7.png";